const checkIfIsCommentShared = function () {
    return (window.location.hash.substr(0, 8) === '#comment'
        && window.location.hash.length > 8);
};

export const init = (commentsCollection) => {
    if (checkIfIsCommentShared()) {
        const id = window.location.hash.substr(8);
        const baseModel = commentsCollection.findBaseCommentById(id);

        if (baseModel) {
          baseModel.fireEvent('focused');
          document.dispatchEvent(new CustomEvent('FocusComment', {
            detail: { id },
          }))
        } else {
          const model = commentsCollection.findById(id);
          if (!model) {
            return;
          }
          const parentCommentId = model.get('parentCommentId');
          document.dispatchEvent(new CustomEvent('FocusComment', {
            detail: { id, parentCommentId },
          }));
        }
    }
};

export default { init, checkIfIsCommentShared };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/expose-shared-comment.js